import React from 'react';
import ContactForm from '../components/ContactForm';
import { IconDiscord, IconMail, IconTwitter } from '../components/Icons';
import './Contact.css';

const METHODS = [
  { Icon: IconDiscord, label: 'Discord', value: 'discord.gg/permsystems',  href: 'https://discord.gg/permsystems' },
  { Icon: IconMail,    label: 'Email',   value: 'support@permsystems.com',  href: 'mailto:support@permsystems.com' },
  { Icon: IconTwitter, label: 'Twitter', value: '@permsystems',             href: 'https://twitter.com/permsystems' },
];

export default function Contact() {
  return (
    <div className="page contact-page">
      <section className="contact-hero">
        <div className="contact-hero__blob" aria-hidden="true" />
        <div className="container animate-fade-up">
          <span className="eyebrow">Get In Touch</span>
          <h1 className="display-title" style={{ maxWidth: 600 }}>
            We would love to<br />
            <span style={{ color: 'var(--blue-dark)' }}>hear from you.</span>
          </h1>
          <p className="section-body">
            Whether you have a question, a bug report, or a custom project in
            mind, our team is ready to help.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-layout">
          <div className="animate-fade-up">
            <h2 className="section-title" style={{ fontSize: '1.5rem' }}>Send us a message</h2>
            <p style={{ color: 'var(--gray-dk)', fontSize: '0.9rem', marginTop: 8, marginBottom: 28 }}>
              Fill in the form and we will respond within 24 to 48 hours.
            </p>
            <ContactForm />
          </div>

          <div className="contact-info animate-fade-up delay-2">
            <h3 className="contact-info__title">Other ways to reach us</h3>
            <div className="contact-info__methods">
              {METHODS.map(({ Icon, label, value, href }) => (
                <a key={label} href={href} className="contact-method"
                   target="_blank" rel="noopener noreferrer">
                  <div className="icon-wrap icon-wrap--sm"><Icon size={16} /></div>
                  <div>
                    <p className="contact-method__label">{label}</p>
                    <p className="contact-method__value">{value}</p>
                  </div>
                </a>
              ))}
            </div>
            <div className="contact-info__note">
              <strong>Response time</strong><br />
              We typically respond within 24 hours on Discord and 48 hours via email.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}